import Modal from "react-bootstrap/Modal";
import Button from "../buttons/button";
import { CancelSvg } from "../../../svgFiles/CancelSvg";
import { PrevSvg } from "../../../svgFiles/PrevSvg";
import "./commonModal.css";

export function CommonModalFooter({
  children,
  className = "common-modal-footer d-flex gap-3 mt-4",
  align = "start",
}) {
  const alignClass =
    align === "center"
      ? "justify-content-center"
      : align === "end"
        ? "justify-content-end"
        : "";

  return (
    <div className={`${className} ${alignClass}`.trim()}>{children}</div>
  );
}

const CommonModal = ({
  children,
  show,
  setShow,
  className = "",
  style,
  dialogClassName = "",
  title,
  centered = false,
  onHide,
  footer,
  headerActions = null,
  onConfirm,
  onCancel,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmLoading = false,
  confirmDisabled = false,
  cancelDisabled = false,
  footerOrder = "confirm-first",
  footerAlign = "start",
  buttonSize = "lg",
  onBack,
  closeOnBackdrop = true,
  enforceFocus = true,
}) => {
  const handleClose = () => {
    onHide?.();
    setShow?.(false);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    handleClose();
  };

  const renderDefaultFooter = () => {
    if (!onConfirm) return null;

    const confirmBtn = (
      <Button
        key="confirm"
        label={confirmLabel}
        onClick={onConfirm}
        size={buttonSize}
        loading={confirmLoading}
        disabled={confirmDisabled || confirmLoading}
      />
    );
    const cancelBtn = (
      <Button
        key="cancel"
        label={cancelLabel}
        onClick={handleCancel}
        className="cancel"
        size={buttonSize}
        disabled={cancelDisabled || confirmLoading}
      />
    );

    const buttons =
      footerOrder === "cancel-first"
        ? [cancelBtn, confirmBtn]
        : [confirmBtn, cancelBtn];

    return (
      <CommonModalFooter align={footerAlign}>{buttons}</CommonModalFooter>
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={className}
      style={style}
      dialogClassName={dialogClassName}
      centered={centered}
      backdrop={closeOnBackdrop ? true : "static"}
      keyboard={closeOnBackdrop}
      container={typeof document !== "undefined" ? document.body : undefined}
      enforceFocus={enforceFocus}
      restoreFocus
    >
      <Modal.Header
        className={`border-0 p-4 common-modal-header${onBack ? " common-modal-header--with-back" : ""}`}
      >
        {onBack && (
          <button
            type="button"
            className="common-modal-back btn btn-link p-0 border-0"
            onClick={onBack}
            aria-label="Back"
          >
            <PrevSvg />
          </button>
        )}
        <Modal.Title dangerouslySetInnerHTML={{ __html: title }} />
        <div className="common-modal-header__actions">
          {headerActions}
          <button
            type="button"
            className="common-modal-close btn btn-link p-0 border-0"
            onClick={handleClose}
            aria-label="Close"
          >
            <CancelSvg />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="p-4 pt-0 common-modal-body">
        {children}
        {footer ?? renderDefaultFooter()}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;
